export const visuallyHidden = {
  border: 0,
  margin: -1,
  padding: 0,
  width: "1px",
  height: "1px",
  overflow: "hidden",
  position: "absolute",
  whiteSpace: "nowrap",
  clip: "rect(0 0 0 0)",
};

export function emptyRows(
  page: number,
  rowsPerPage: number,
  arrayLength: number,
) {
  return page ? Math.max(0, (1 + page) * rowsPerPage - arrayLength) : 0;
}

function descendingComparator(a: any, b: any, orderBy: string) {
  if (a[orderBy] === null) {
    return 1;
  }
  if (b[orderBy] === null) {
    return -1;
  }
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}
export function getComparator(order: string, orderBy: string) {
  return order === "desc"
    ? (a: any, b: any) => descendingComparator(a, b, orderBy)
    : (a: any, b: any) => -descendingComparator(a, b, orderBy);
}

export function getCustomComparator(order: string, columnSortFn: Function) {
  if (typeof columnSortFn !== "function") {
    throw new Error("columnSortFn must be a function");
  }

  // If the sort function expects two arguments, treat it as a comparator
  if (columnSortFn.length >= 2) {
    return order === "desc"
      ? (a: any, b: any) => (columnSortFn as any)(b, a)
      : (a: any, b: any) => (columnSortFn as any)(a, b);
  }

  // Otherwise, treat it as an accessor that returns a value to sort by
  const compareValues = (aVal: any, bVal: any) => {
    if (aVal === null || aVal === undefined) return 1;
    if (bVal === null || bVal === undefined) return -1;
    if (aVal < bVal) return -1;
    if (aVal > bVal) return 1;
    return 0;
  };

  return (a: any, b: any) => {
    const aVal = (columnSortFn as any)(a);
    const bVal = (columnSortFn as any)(b);
    const base = compareValues(aVal, bVal);
    return order === "desc" ? -base : base;
  };
}

export function applyFilter({
  inputData,
  comparator,
  filterName,
  fieldToFilter,
}: {
  inputData: any[] | undefined;
  comparator: any;
  filterName: string;
  fieldToFilter: string | ((data: any, filterName: string) => void);
}) {
  const stabilizedThis =
    inputData?.map((el: any, index: number) => [el, index]) || [];

  stabilizedThis.sort((a: any, b: any) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });

  inputData = stabilizedThis.map((el: any) => el[0]);

  if (filterName && typeof fieldToFilter === "string") {
    inputData = inputData.filter(
      (user: any) =>
        user[fieldToFilter].toLowerCase().indexOf(filterName.toLowerCase()) !==
        -1,
    );
  } else if (filterName && typeof fieldToFilter === "function") {
    inputData = inputData.filter((el: any) => fieldToFilter(el, filterName));
  }

  return inputData || [];
}
